
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  getAntManageList,
  delAntManageList,
  patchAntManageInfo,
  getChangeBalance,
  getAssignBalance,
  getAntStatistics,
  getAntExport,
  getSaleAction,
  setUnfreeze,
  setFreeze
} from '@/api/antManage/antManage'
import pagination from '@/components/Pagination/index.vue'
import addAntManage from './components/addAntManage.vue'
import PicsUploader from '@/components/PicsUploader/index.vue'
import detailManage from '@/components/AntDetail/detailManage.vue'
import transactionDetails from '@/components/AntDetail/transactionDetails.vue'
import friendsList from '@/components/AntDetail/friends-list.vue'
import { statusList } from '@/utils/constant'
import { AppModule } from '@/store/modules/app'
import { Form as ElForm } from 'element-ui'
import { delObjEmptyKey } from '@/utils'
import { getCurrentDate, dateToSeconds, pickerOptions } from '@/utils/dateTime'
import { getProductList } from '@/api/product/product'
import editAccount from '@/views/product/accountManage.vue'
import { getProductAccountList } from '@/api/product/productAccount'

const initDate = getCurrentDate()
@Component({
  name: 'merchantList',
  components: {
    pagination,
    addAntManage,
    PicsUploader,
    detailManage,
    transactionDetails,
    friendsList,
    editAccount
  }
})
export default class extends Vue {
  private form: any = {
    name: '',
    id: null,
    ant_type: '',
    start_time: initDate[0],
    end_time: initDate[1],
    ancestor: '',
    descendant: '',
    sale_status: null,
    login_ip: '',
    recharge_address: '',
    phone: ''
  }

  private ancestor: string = ''
  private merchantList: any[] = []
  private currentMerchant: any = {}
  private statusList = statusList
  private total = 0
  private listQuery = {
    page: 1,
    limit: 20
  }
  private pickerOptions: any = pickerOptions
  private listLoading: boolean = true
  private dialogVisible: boolean = false

  private drawer: boolean = false
  private tabName: string = 'basicInformation'
  private action: string = ''

  private infoForm: any = {
    amount: '',
    remarks: '',
    in_or_out: '',
    attach: '',
    operation_type: 'change_balance',
    google_code: ''
    // ancestor: ''
  }
  private rules: any = {
    amount: [
      { required: true, message: 'Please enter amount', trigger: 'blur' }
    ],
    remarks: [
      { required: true, message: 'Please enter remarks', trigger: 'blur' }
    ],
    in_or_out: [
      {
        required: true,
        message: 'Please enter decrease or increase',
        trigger: 'change'
      }
    ],
    attach: [
      { required: true, message: 'Please enter attach', trigger: 'blur' }
    ],
    operation_type: [
      {
        required: true,
        message: 'Please enter operation_type',
        trigger: 'change'
      }
    ],
    google_code: [
      { required: true, message: 'Please enter google code', trigger: 'blur' }
    ]
  }

  private saleRules: any = {
    ant_account: [
      { required: true, message: 'Please enter ant ID', trigger: 'blur' }
    ],
    action: [
      { required: true, message: 'Please enter action', trigger: 'change' }
    ],
    account_ids: [
      { required: true, message: 'Please enter account IDS', trigger: 'blur' }
    ]
  }

  private assignForm: any = {
    from_ant: '',
    to_ant: '',
    amount: '',
    ancestor: ''
  }
  private assignRules: any = {
    from_ant: [
      { required: true, message: 'Please enter from_ant', trigger: 'blur' }
    ],
    to_ant: [
      { required: true, message: 'Please enter to_ant', trigger: 'blur' }
    ],
    amount: [
      { required: true, message: 'Please enter amount', trigger: 'blur' }
    ],
    ancestor: [
      { required: true, message: 'Please enter ancestor', trigger: 'blur' }
    ]
  }

  private selectType: string = ''
  private formName: string = ''

  get language() {
    return AppModule.language
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换22
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      if (this.selectType === 'ancestor') {
        delete this.form.descendant
        delete this.form.name
      } else if (this.selectType === 'descendant') {
        delete this.form.ancestor
        delete this.form.name
      } else if (this.selectType === '') {
        delete this.form.ancestor
        delete this.form.descendant
      }
      const data: any = {
        ...this.form,
        page_size: this.pagesize,
        page: this.currentPage
      }
      delObjEmptyKey(data)
      await getAntManageList(data).then((res: any) => {
        this.total = res.count
        this.merchantList = res.results
        setTimeout(() => {
          this.listLoading = false
        }, 0.5 * 1000)
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private statisticsData: any = {}
  private async getAntStatistics() {
    try {
      const data: any = {
        ...this.form
      }
      delObjEmptyKey(data)
      await getAntStatistics(data).then((res: any) => {
        this.statisticsData = res
      })
    } catch (e) {}
  }

  private master: any = []
  private loadingList = false
  private accountName: string = ''
  private async remoteMethod(query) {
    try {
      this.loadingList = true
      const data: any = {
        name: query,
        page_size: 100
      }
      await getAntManageList(data).then((res: any) => {
        this.master = res.results
        this.loadingList = false
      })
    } catch (e) {
      this.loadingList = false
    }
  }

  private isShow: boolean = true
  private async select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
    this.getAntStatistics()
  }

  // 创建时间监听
  @Watch('date', { deep: true, immediate: true })
  protected pickerChange() {
    if (this.date) {
      this.form.start_time = dateToSeconds(this.date[0])
      this.form.end_time = dateToSeconds(this.date[1])
    } else {
      this.date = getCurrentDate()
    }
  }

  private date: any[] = getCurrentDate()
  private reset() {
    this.form = {
      name: '',
      id: null,
      ant_type: '',
      start_time: null,
      end_time: null,
      descendant: '',
      ancestor: ''
    }
    this.ancestor = ''
    this.currentPage = 1
    this.date = []
    this.isShow = true
    this.selectType = ''
    this.date = getCurrentDate()
    // this.getMerchantList(false)
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
      this.getAntStatistics()
    })
  }
  private closeDrawer(isManual: boolean = false) {
    if (isManual) {
      this.drawer = false
    }
    this.tabName = 'basicInformation'
    if (this.currentMerchant.ant_type === 'sub') {
      let data: any = {
        username: this.ancestor
      }
      this.subaccount(data)
    } else {
      this.hadleGetFilesListApi()
    }
  }

  private openDialogVisible(action: string) {
    this.action = action
    this.dialogVisible = true
  }

  private closeDialogVisible() {
    this.dialogVisible = false
    this.hadleGetFilesListApi()
  }

  private AssignVisible: boolean = false
  private closeAssignVisible() {
    this.AssignVisible = false
    let data: any = {
      username: this.ancestor
    }
    this.subaccount(data)
  }
  private quota(row: any) {
    this.AssignVisible = true
    this.assignForm.to_ant = row.username
    this.assignForm.ancestor = this.ancestor
  }

  private changeAssign() {
    ;(this.$refs.assignForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          let data = {
            ...this.assignForm
          }
          this.listLoading = true
          await getAssignBalance(data).then(res => {
            this.$message({
              message: 'Create successful!',
              type: 'success'
            })
            this.closeAssignVisible()
            this.listLoading = false
            // this.hadleGetFilesListApi()
          })
        } catch (e) {
          // this.back()
          this.listLoading = false
        }
      } else {
        return false
      }
    })
  }

  private currentAccountId: any = {}
  private currentProduct: any = {
    id: ''
  }
  queryForm = {
    currency: AppModule.currentCurrencyType,
    ordering: ''
  }
  private onProductList: any[] = []
  private productList: any = []
  private openEdit(merchant: any) {
    this.currentMerchant = merchant
    this.currentAccountId = merchant.id
    this.drawer = true
  }

  // 删除商户
  private del(obj: any) {
    this.$confirm('Are you sure to delete it?', {
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      type: 'warning',
      callback: action => {
        if (action === 'confirm') {
          this.currentMerchant = obj
          this.delMerchant({ id: obj.id })
        }
      }
    })
  }

  private async delMerchant(data: any) {
    await delAntManageList(data).then(() => {
      this.$message.success('Delete Successfully')
      this.hadleGetFilesListApi()
    })
  }

  private async setStatus(obj: any) {
    await patchAntManageInfo(obj).then(res => {
      this.$message.success('Modified Successfully')
    })
  }

  // 合并
  private async subaccount(row: any) {
    try {
      this.listLoading = true
      this.ancestor = row.username
      const data: any = {
        ancestor: row.username
        // name: row.username,
        // ant_type: 'sub'
      }
      await getAntManageList(data).then((res: any) => {
        this.total = res.count
        this.merchantList = res.results
        setTimeout(() => {
          this.listLoading = false
        }, 0.5 * 1000)
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private showBalanceVisible: boolean = false
  private nickName: string = ''
  private nickId: any = null
  private balance(row) {
    this.showBalanceVisible = true
    this.nickName = row.username
    this.nickId = row.id
  }
  private closeBalanceVisible() {
    this.infoForm = {
      amount: '',
      remarks: '',
      in_or_out: '',
      attach: '',
      operation_type: 'change_balance',
      google_code: ''
    }
    this.showBalanceVisible = false
  }

  private flag: boolean = false
  private flagLoading: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }
  private changeBalance() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.flag = true
        this.flagLoading = true
        try {
          if (this.infoForm.attach === '') {
            delete this.infoForm.attach
          }
          if (this.infoForm.google_code === '') {
            delete this.infoForm.google_code
          }
          let data = {
            name: this.nickId,
            body: this.infoForm
          }

          await getChangeBalance(data).then(res => {
            this.$message({
              message: 'Create successful!',
              type: 'success'
            })
            this.flagLoading = false
            this.flagStr()
            this.closeBalanceVisible()
            this.hadleGetFilesListApi()
          })
        } catch (e) {
          this.flagLoading = false
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }

  // 上传图片
  private getPicList(fileList: any) {
    this.infoForm.attach = fileList.map((item: any) => {
      if (item.response) {
        return item.response.file_path
      } else {
        return item.url
      }
    })
  }

  // 导出
  private sendLoading: boolean = false
  private async exportData() {
    try {
      this.sendLoading = true
      const data: any = {
        ...this.form
      }
      delObjEmptyKey(data)
      await getAntExport(data).then(() => {
        this.$message({
          message: 'The form has been sent to your mailbox, please check it!',
          type: 'success'
        })
        this.sendLoading = false
      })
    } catch (e) {
      this.sendLoading = false
      this.$message({
        message: 'Export failure!',
        type: 'error'
      })
    }
  }

  private saleVisible: boolean = false
  private saleForm: any = {
    ant_account: '',
    action: '',
    account_ids: []
  }
  // 销售
  private saleData() {
    this.saleVisible = true
  }
  private closeSaleVisible() {
    this.saleVisible = false
    this.saleForm = {
      ant_account: '',
      action: '',
      account_ids: []
    }
    this.hadleGetFilesListApi()
    this.getAntStatistics()
  }
  // currency: AppModule.currentCurrencyType,
  private saleBtn: boolean = false
  private changeSales() {
    ;(this.$refs.saleForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.saleBtn = true
        let data = {}
        if (this.saleForm.action === 'start_sale') {
          data = {
            ...this.saleForm
          }
        } else {
          data = {
            ant_account: this.saleForm.ant_account,
            action: this.saleForm.action
          }
        }
        await getSaleAction(data).then((res: any) => {
          this.$message.success('Successful operation!')
          this.saleBtn = false
          this.closeSaleVisible()
        })
      }
    })
  }
  // 创建时间监听
  @Watch('saleForm.ant_account', { deep: true, immediate: true })
  private pickerSale() {
    this.master.forEach(item => {
      if (this.saleForm.ant_account === item.id) {
        this.accountName = item.username
        this.getProductLists()
      }
    })
  }

  // 获取产品列表
  private async getProductLists() {
    const data: any = {
      currency: this.queryForm.currency
    }
    await getProductList(data).then((res: any) => {
      this.productList = res
      this.onProductList = this.productList.filter((item: any) => {
        return this.queryForm.currency === item.currency
      })
      if (this.productList.length >= 1) {
        // this.currentProduct.id =
        this.productList.forEach(item => {
          if (item.name === 'IndiaQR') {
            this.currentProduct.id = item.id
          }
        })
      }
      this.accountIDList()
    })
  }
  private accountList: any = []
  private async accountIDList() {
    try {
      const params = {
        ant_username: this.accountName,
        currency: this.queryForm.currency,
        product: this.currentProduct.id,
        page_size: 100,
        page: 1
      }
      await getProductAccountList(params).then((res: any) => {
        this.accountList = res.results
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  // 批量操作
  private batchUnfreeze: any[] = []
  private opnekickUnfreezeShow: boolean = false
  private currentItems: any[] = []
  private currentID: any[] = []
  private totalAmount: any = 0
  private expectedThawing: any = 0

  private unfreezeForm: any = {
    ant_ids: [],
    cause: 'topup_unfreeze',
    unfreeze_percent: '70'
  }
  private handleSelectionChange(list) {
    this.batchUnfreeze = list
  }

  private changeUnfreezeCause(value) {
    if (value === 'buy_unfreeze') {
      this.currentItems = []
      this.currentID = []
      this.expectedThawing = 0
      for (let i = 0; i < this.batchUnfreeze.length; i++) {
        this.currentItems.push(this.batchUnfreeze[i])
        this.currentID.push(this.batchUnfreeze[i].id)
        // 总数
        this.totalAmount = this.currentItems.reduce(
          (sum, item) => sum + (item.buy_freeze_balance || 0),
          0
        )
        const percent = parseFloat(this.unfreezeForm.unfreeze_percent) || 0
        let a: any = (
          (this.batchUnfreeze[i].buy_freeze_balance * percent) /
          100
        )
          .toFixed(6)
          .replace(/\.?0+$/, '')
        if (a) {
          this.expectedThawing += parseFloat(a)
        } else {
          this.expectedThawing = 0
        }
      }
    } else {
      this.currentItems = []
      this.currentID = []
      this.expectedThawing = 0
      for (let i = 0; i < this.batchUnfreeze.length; i++) {
        this.currentItems.push(this.batchUnfreeze[i])
        this.currentID.push(this.batchUnfreeze[i].id)
        // 总数
        this.totalAmount = this.currentItems.reduce(
          (sum, item) => sum + (item.manage_freeze_balance || 0),
          0
        )
        const percent = parseFloat(this.unfreezeForm.unfreeze_percent) || 0
        let a: any = (
          (this.batchUnfreeze[i].manage_freeze_balance * percent) /
          100
        )
          .toFixed(6)
          .replace(/\.?0+$/, '')
        if (a) {
          this.expectedThawing += parseFloat(a)
        } else {
          this.expectedThawing = 0
        }
      }
    }
  }

  private opnekickUnfreeze() {
    this.opnekickUnfreezeShow = true
    this.currentItems = []
    this.currentID = []
    this.expectedThawing = 0
    for (let i = 0; i < this.batchUnfreeze.length; i++) {
      this.currentItems.push(this.batchUnfreeze[i])
      this.currentID.push(this.batchUnfreeze[i].id)
      // 总数
      this.totalAmount = this.currentItems.reduce(
        (sum, item) => sum + (item.manage_freeze_balance || 0),
        0
      )
      const percent = parseFloat(this.unfreezeForm.unfreeze_percent) || 0
      let a: any = (
        (this.batchUnfreeze[i].manage_freeze_balance * percent) /
        100
      )
        .toFixed(6)
        .replace(/\.?0+$/, '')
      if (a) {
        this.expectedThawing += parseFloat(a)
      } else {
        this.expectedThawing = 0
      }
    }
  }

  private changeUnfreezePercent(value) {
    this.expectedThawing = 0
    if (this.unfreezeForm.cause === 'buy_unfreeze') {
      for (let i = 0; i < this.batchUnfreeze.length; i++) {
        const percent = parseFloat(value) || 0
        let a: any = (
          (this.batchUnfreeze[i].buy_freeze_balance * percent) /
          100
        )
          .toFixed(6)
          .replace(/\.?0+$/, '')
        if (a) {
          this.expectedThawing += parseFloat(a)
        } else {
          this.expectedThawing = 0
        }
      }
    } else {
      for (let i = 0; i < this.batchUnfreeze.length; i++) {
        const percent = parseFloat(value) || 0
        let a: any = (
          (this.batchUnfreeze[i].manage_freeze_balance * percent) /
          100
        )
          .toFixed(6)
          .replace(/\.?0+$/, '')
        if (a) {
          this.expectedThawing += parseFloat(a)
        } else {
          this.expectedThawing = 0
        }
      }
    }
  }

  private closeOpnekickUnfreeze() {
    this.opnekickUnfreezeShow = false
    this.unfreezeForm.unfreeze_percent = '70'
  }
  private unfreezeLoading: boolean = false
  private async saveClickChange() {
    ;(this.$refs.unfreezeForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.unfreezeLoading = true
        const data: any = {
          ant_ids: this.currentID,
          cause: this.unfreezeForm.cause,
          unfreeze_percent: this.unfreezeForm.unfreeze_percent
        }
        await setUnfreeze(data).then((res: any) => {
          this.$message({
            message: 'Operation successfully!',
            type: 'success'
          })
          this.unfreezeLoading = false
          this.closeOpnekickUnfreeze()
        })
      } else {
        return false
      }
    })
  }

  private freezeForm: any = {
    ant_ids: [],
    cause: 'topup_unfreeze',
    freeze_percent: '30'
  }
  private opnekickFreezeShow: boolean = false
  private opnekickFreeze() {
    this.opnekickFreezeShow = true
    this.currentItems = []
    this.currentID = []
    this.expectedThawing = 0
    for (let i = 0; i < this.batchUnfreeze.length; i++) {
      this.currentItems.push(this.batchUnfreeze[i])
      this.currentID.push(this.batchUnfreeze[i].id)
      // 总数
      this.totalAmount = this.currentItems.reduce(
        (sum, item) => sum + (item.balance || 0),
        0
      )
      const percent = parseFloat(this.freezeForm.freeze_percent) || 0
      let a: any = ((this.batchUnfreeze[i].balance * percent) / 100)
        .toFixed(6)
        .replace(/\.?0+$/, '')
      if (a) {
        this.expectedThawing += parseFloat(a)
      } else {
        this.expectedThawing = 0
      }
    }
  }

  private changeFreezeCause(value) {
    if (value === 'buy_unfreeze') {
      this.currentItems = []
      this.currentID = []
      this.expectedThawing = 0
      for (let i = 0; i < this.batchUnfreeze.length; i++) {
        this.currentItems.push(this.batchUnfreeze[i])
        this.currentID.push(this.batchUnfreeze[i].id)
        // 总数
        this.totalAmount = this.currentItems.reduce(
          (sum, item) => sum + (item.balance || 0),
          0
        )
        const percent = parseFloat(this.freezeForm.freeze_percent) || 0
        let a: any = (
          (this.batchUnfreeze[i].balance * percent) /
          100
        )
          .toFixed(6)
          .replace(/\.?0+$/, '')
        if (a) {
          this.expectedThawing += parseFloat(a)
        } else {
          this.expectedThawing = 0
        }
      }
    } else {
      this.currentItems = []
      this.currentID = []
      this.expectedThawing = 0
      for (let i = 0; i < this.batchUnfreeze.length; i++) {
        this.currentItems.push(this.batchUnfreeze[i])
        this.currentID.push(this.batchUnfreeze[i].id)
        // 总数
        this.totalAmount = this.currentItems.reduce(
          (sum, item) => sum + (item.balance || 0),
          0
        )
        const percent = parseFloat(this.freezeForm.freeze_percent) || 0
        let a: any = ((this.batchUnfreeze[i].balance * percent) / 100)
          .toFixed(6)
          .replace(/\.?0+$/, '')
        if (a) {
          this.expectedThawing += parseFloat(a)
        } else {
          this.expectedThawing = 0
        }
      }
    }
  }
  private changeFreezePercent(value) {
    this.expectedThawing = 0
    if (this.freezeForm.cause === 'buy_unfreeze') {
      for (let i = 0; i < this.batchUnfreeze.length; i++) {
        const percent = parseFloat(value) || 0
        let a: any = (
          (this.batchUnfreeze[i].balance * percent) /
          100
        )
          .toFixed(6)
          .replace(/\.?0+$/, '')
        if (a) {
          this.expectedThawing += parseFloat(a)
        } else {
          this.expectedThawing = 0
        }
      }
    } else {
      for (let i = 0; i < this.batchUnfreeze.length; i++) {
        const percent = parseFloat(value) || 0
        let a: any = ((this.batchUnfreeze[i].balance * percent) / 100)
          .toFixed(6)
          .replace(/\.?0+$/, '')
        if (a) {
          this.expectedThawing += parseFloat(a)
        } else {
          this.expectedThawing = 0
        }
      }
    }
  }

  private closeOpnekickFreeze() {
    this.opnekickFreezeShow = false
    this.freezeForm.freeze_percent = '30'
  }
  private saveClickFreeze() {
    ;(this.$refs.freezeForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.unfreezeLoading = true
        const data: any = {
          ant_ids: this.currentID,
          cause: this.freezeForm.cause,
          freeze_percent: this.freezeForm.freeze_percent
        }
        await setFreeze(data).then((res: any) => {
          this.$message({
            message: 'Operation successfully!',
            type: 'success'
          })
          this.unfreezeLoading = false
          this.closeOpnekickFreeze()
        })
      } else {
        return false
      }
    })
  }

  private handleSortChange(column, prop, order) {
    if (!column.order) {
      let el: any = this.$refs.table
      el.sort('data', 'ascending')
    }
    if (column.prop === 'balance') {
      column.order === 'ascending'
        ? (this.form.ordering = 'balance')
        : column.order === 'descending'
        ? (this.form.ordering = '-balance')
        : (this.form.ordering = '')
    } else if (column.prop === 'manage_freeze_balance') {
      column.order === 'ascending'
        ? (this.form.ordering = 'manage_freeze_balance')
        : column.order === 'descending'
        ? (this.form.ordering = '-manage_freeze_balance')
        : (this.form.ordering = '')
    }
    this.hadleGetFilesListApi()
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    // this.masterListApi()
    this.hadleGetFilesListApi()
    this.getAntStatistics()
    this.getProductLists()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.antManage`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
